<div class="ft-panel ft-story-panel highlight" (click)="selected.emit()">
    <div class="ft-content photo">
        <div class="ft-bg-image"
             [style.background-image]="story()?.PhotoUriSmall ? 'url(' + story().PhotoUriSmall + ')' : null"></div>
        <div class="ft-story-info">
            @if (story()?.ProfilePhotoUrl) {
                <img [src]="story().ProfilePhotoUrl" class="ft-profile-photo" />
            }
            <div class="ft-person-name">{{ story()?.FullName }}</div>
            @if (story()?.Quote) {
                <div class="ft-story-quote ft-text-plus-1">
                    &ldquo;{{ truncate(story().Quote, 200) }}&rdquo;
                </div>
            }
            @if (!story()?.Quote && story()?.Caption) {
                <div class="ft-story-photocaption">
                    {{ truncate(story().Caption, 200) }}
                </div>
            }
        </div>
    </div>
</div>
